import ZInputFile from './ZInputFile.vue'

export default ZInputFile
